<template>
    <div class="range-slider">
        <div class="w-50">
            <div class="mb-2">
                <vue-slider tooltip="none" :interval=interval :min=minPrice :max=maxPrice  @change="onInput" :value="valueLocal" :enable-cross="false"/>
            </div>
        </div>
        <div class="form-control d-flex justify-content-between" style="max-width: 150px">
            <b>&euro; {{start}}</b>-
            <b>&euro; {{end}}</b>
        </div>
    </div>
</template>

<script>
import {formatMoney} from '../../../utils/formatter'

export default {
  name: 'PriceRangeSlider',
  props: {
    value: Array,
    minPrice: Number,
    maxPrice: Number
  },
  computed: {
    valueLocal () {
      return this.value === null ? [this.minPrice, this.maxPrice] : this.value
    },
    start () {
      return this.valueLocal && this.valueLocal.length > 0 ? formatMoney(this.valueLocal[0]) : 0
    },
    end () {
      return this.valueLocal && this.valueLocal.length > 0 ? formatMoney(this.valueLocal[1]) : 0
    },
    interval () {
      const calc = (this.maxPrice - this.minPrice) / 10
      return calc < 1 ? 1 : calc
    }
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    },
    reset () {
      this.$emit('input', [this.minPrice, this.maxPrice])
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/PriceRangeSlider.vue